import controller from './sales-home.controller';
import templateBase from './templates/sales-home-base.view.html';
import adaptativo from './templates/sales-home-adaptativo.view.html';

let SalesHomeComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
    if(__env.adaptative){
        return adaptativo;
    } else {
        return templateBase;
    }
}

export default SalesHomeComponent;



/** WEBPACK FOOTER **
 ** ./www/components/sales-home/sales-home.component.js
 **/